import { defineMessages } from "react-intl";

import { $t } from "../../../utils/intl";

export const browserStorageRequiredTexts = defineMessages({
  title: {
    defaultMessage: "Browser Storage Required",
    id: "frbNSF",
  },
  description: {
    defaultMessage:
      "This application requires browser storage and cookies to function properly. Your current privacy settings are blocking access. Please enable storage and cookies for this site and reload the page.",
    id: "euDJ6T",
  },
});

export const texts = {
  title: $t(browserStorageRequiredTexts.title),
  description: $t(browserStorageRequiredTexts.description),
};
